<template>
  <div class="flex flex-col gap-5 mt-8">
    <div class="flex items-center gap-2 p-1.5">
      <component :is="platformIcon" class="flex-shrink-0 text-icon-disabled" />
      <BaseText type="heading" size="overline" class="text-text-subdued flex-shrink-0 uppercase">
        All {{ platformName }} Metrics
      </BaseText>
      <div class="w-full border-t border-border-normal" />
    </div>
    <div v-if="Object.keys(getMetrics).length > 0" class="relative metric-container">
      <div v-for="(metricSection) in metricSections" :key="metricSection">
        <MetricSectionList
          :ref="metricSection"
          :section-icon="metricIcons?.[metricSection]"
          :section-id="metricSection"
          :data="getMetrics[metricSection]"
          :preset-list="columns"
          :fuzzy-results="getFuzzyResults"
          :show-divider="metricSection !== lastVisibleSection || hasFollowingSection"
          @handleHover="addHover"
          @add="$emit('metricAdd', $event)"
        />
      </div>
    </div>
    <!-- Tooltip -->
    <MetricHoverTooltip :hovered-metric="hoveredMetric" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { platformNameMap, platformIconMap } from '@/utils/lens/dataSourceUtils'

// Components
import MetricSectionList from '../MetricSectionList.vue'
import MetricHoverTooltip from '../MetricHoverTooltip.vue'

// Icons
import MetaMetricsIcon from '../../../globals/Icons/LensIcons/MetaMetricsIcon.vue'
import sectionIcons from '../../../../utils/lens/metricIconMap'

export default {
  name: 'MetaMetricsSettings',
  components: {
    MetaMetricsIcon,
    MetricSectionList,
    MetricHoverTooltip
  },
  props: {
    preset: {
      type: Object,
      default: () => {}
    },
    columns: {
      type: Array,
      default: () => []
    },
    // Whether a section renders after this block, which decides if the last section keeps its divider
    hasFollowingSection: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const metricIcons = sectionIcons
    return {
      metricIcons,
      hoveredMetric: null
    }
  },
  computed: {
    ...mapGetters('MetricsModule', ['getMetricsPlatform', 'getFuzzyResults', 'getMetrics', 'getMetricSearch', 'getMetricLookup']),
    platformName () {
      return platformNameMap[this.getMetricsPlatform]
    },
    platformIcon () {
      return platformIconMap[`mono-${this.getMetricsPlatform}`]
    },
    metricSections () {
      return Object.keys(this.getMetrics).filter(key => key !== 'foreplay_metrics')
    },
    // A divider separates a section from the next one, so the final section renders without it
    lastVisibleSection () {
      if (!this.getMetricSearch?.length) return this.metricSections[this.metricSections.length - 1]
      const matched = new Set([...this.getFuzzyResults].map(key => this.getMetricLookup?.[key]?.parent_group))
      const visible = this.metricSections.filter(section => matched.has(section))
      return visible[visible.length - 1]
    }
  },
  methods: {
    addHover (metric) {
      this.hoveredMetric = metric
    }
  }
}
</script>
